import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AuthGuard({ children }) {
  const { authenticated, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading && !authenticated) {
      navigate("/login", { replace: true, state: { from: location.pathname } });
    }
  }, [loading, authenticated, navigate, location.pathname]);

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", backgroundColor: "#000", color: "#0ff" }}>
        <div style={{ fontSize: "1.5rem" }}>Authentification en cours...</div>
      </div>
    );
  }

  return authenticated ? children : null;
}
